import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { DsLoadingModule } from '@bmw-ds/components';

import { InputFieldComponent } from '../../../form/components/input-field/input-field.component';
import { useI18n } from '../../../i18n/services/i18n.service';
import { SearchButtonComponent } from '../search-button/search-button.component';

@Component({
  selector: 'cdf-form-search-for-vin',
  imports: [InputFieldComponent, SearchButtonComponent, DsLoadingModule],
  host: { class: 'd-flex flex-column gap-2x' },
  template: `
    <h3>{{ i18n('headings.searchForVIN') }}</h3>

    <div class="d-flex gap-2x">
      <cdf-input-field id="vin" [placeholder]="i18n('placeholder.vin')" [(model)]="vin" />
      <cdf-search-button
        ds-loading
        [isLoading]="saving()"
        id="search-vin-button"
        [disabled]="button().disabled"
        [tooltip]="button().tooltip"
        [label]="i18n('placeholder.vin')"
        (searchClick)="searchVIN.emit()"
      />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSearchForVinComponent {
  readonly i18n = useI18n();

  readonly vin = model.required<string | undefined>();
  readonly saving = input(false);
  readonly searchVIN = output();

  readonly button = computed(() => {
    const isValid = this.vin()?.length === 17;
    return {
      disabled: !isValid,
      tooltip: isValid ? '' : this.i18n('customerSearch.inputVinIsNotValid', { length: this.vin()?.length ?? 0 }),
    };
  });
}
